import React, { useEffect } from "react";
import { loadUserFromStorage } from "_services/oauth";
import { SetBearer } from "utils/axiosHeaders";
import { storeUserError } from "actions/authActions";
import store from "store";

export default function QueueTwin({ location }) {
  useEffect(() => {
    // A login/logout inside the same-origin iframe updates this window's session.
    const sync = event => {
      if (event.key !== "currentUser") return;
      SetBearer();
      if (event.newValue) loadUserFromStorage(store);
      else store.dispatch(storeUserError());
    };
    window.addEventListener("storage", sync);
    return () => window.removeEventListener("storage", sync);
  }, []);
  return (
    <iframe
      title="Queue Digital Twin"
      src={location && location.pathname.indexOf("custom-floormap") >= 0 ? "/queue-twin/index.html?view=floormaps" : "/queue-twin/index.html"}
      style={{ width: "100%", height: "calc(100vh - 150px)", minHeight: 650, border: 0 }}
    />
  );
}
